let projectsLinks = [
  {
    crown: {
      github: "https://github.com/pperdana/crwn-clothing",
      live: "https://crown-cloth-pperdana.netlify.app",
    },
    keeper: {
      github: "https://github.com/pperdana/keeper",
      live: "https://keeper-pperdana.netlify.app",
    },
    todoList: {
      github: "https://github.com/pperdana/todo-list-app",
      live: "https://todolist-pperdana.netlify.app",
    },
    drumKit: {
      github: "https://github.com/pperdana/drum-kit",
      live: "https://drumkit-pperdana.netlify.app",
    },
    ominfood: {
      github: "https://github.com/pperdana/omnifood",
      live: "https://omnifood-pperdana.netlify.app",
    },
  },
];

export default projectsLinks;
